import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Classificazione } from 'src/app/common/models/classificazione';
import { Controparte } from 'src/app/common/models/controparte';
import { SezioneEsitiResponse } from 'src/app/common/models/dto/sezione-esiti-response';
import { Esito } from 'src/app/common/models/esito';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { ModalitaErogazione } from 'src/app/common/models/modalita-erogazione';
import { PraticaFull } from 'src/app/common/models/pratica/pratica-full';
import { SchedaEsecuzione } from 'src/app/common/models/scheda-esecuzione';
import { SezioneEsitiFull } from 'src/app/common/models/sezioni/sezione-esiti-full';
import { SezioneSchedeEsecuzione } from 'src/app/common/models/sezioni/sezione-schede-esecuzione';
import { TipoEsecuzione } from 'src/app/common/models/tipologiche/tipo-esecuzione';
import { TipoEsito } from 'src/app/common/models/tipologiche/tipo-esito';
import { TipoSommaLiquidata } from 'src/app/common/models/tipologiche/tipo-somma-liquidata';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { HelpersService } from "../../../../core/services/helpers.service";
import { OperationsService } from "../../../../core/services/operations.service";
import { FormValidationService } from "../../../services/form-validation.service";

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
    selector: 'div [schede-esecuzione-mod-add]',
  templateUrl: 'schede-esecuzione-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SchedeEsecuzioneModAggiungi {
  pathSchedeEsecuzioneUrl: string;
  idSezione: string;
  fascicolo: FascicoloFull;
  idParent: string;
  idPratica: string;
  idSezioneEsiti: string;
  urlSezioneEsiti: string;
  schedaEsecuzioneForm: FormGroup;
  request: SchedaEsecuzione;

  edit: boolean;
  inserimento: boolean;
  PROPERTIES_SETTINGS = PropertiesSettings;
  msgNoBeneficiari: string;
  selectAll: boolean = true;
  originalRequest: SchedaEsecuzione = new SchedaEsecuzione();
  tipoProvvedimentoOptions: TipoEsito[]=[];
  tipoSommaOptions: TipoSommaLiquidata[]=[];
  modalitaErogazioneOptions: ModalitaErogazione[]=[];
  tipoEsecuzioneOptions: TipoEsecuzione[]=[];
  msgNoControparti: string;
  msgNoClassificazioni: string;
  today: number;
  flagQuantificata: boolean = false;
  flagNonQuantificata: boolean = false;

  praticaFull: PraticaFull;
  classificazione: Classificazione;

  disableSomma: boolean = true;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  esitiAll: Esito[] = [];
  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService,
              private formValidationService: FormValidationService,
              private modalNotifyService: ModalNotifyService) {}

  @Output() onReturn: EventEmitter<SezioneSchedeEsecuzione> = new EventEmitter<SezioneSchedeEsecuzione>();

  inizializza(pathSchedeEsecuzioneUrl, idPratica, idSezione, idSezioneEsiti, urlSezioneEsiti, fascicolo, praticaFull, classificazione, idParent, edit = false, request = new SchedaEsecuzione(null)) {
    this.pathSchedeEsecuzioneUrl = pathSchedeEsecuzioneUrl;
    this.idSezione = idSezione;
    this.idSezioneEsiti = idSezioneEsiti;
    this.urlSezioneEsiti = urlSezioneEsiti;
    this.fascicolo = fascicolo;
    this.idParent = idParent;
    this.idPratica = idPratica;
    this.edit = edit;
    this.inserimento =!edit;
    this.request=request;
    this.praticaFull=praticaFull;
    this.classificazione=classificazione;
    this.originalRequest=new SchedaEsecuzione(request);
    openModal('modalmodaggiungischedaesecuzione');
    this.createForm(request);
    this.readSezioneEsiti(idSezioneEsiti);
    this.initViewToggle();
    this.populateSelect();
    this.msgNoBeneficiari = 'Non esistono esiti da associare';
    this.msgNoControparti = 'Nessuna controparte associata';
    this.msgNoClassificazioni='Nessuna classificazione associata';
    this.today = + new Date();
  }

  createForm(request=new SchedaEsecuzione()) {
    this.request=new SchedaEsecuzione(request);
    if(this.inserimento) this.request.dataCreazione = new Date(this.today).toLocaleDateString();
    this.schedaEsecuzioneForm = this.campiForm.group({
      posizione : [this.praticaFull.posizione],
      // societa: [this.classificazione.materia.label],
      // materia: [this.classificazione.oggetto.label],
      // argomento: [this.classificazione.argomento.label],
      numeroProvvedimento: [this.request.esito ? this.request.esito.numeroEsito : null],
      provvedimento: [this.request.esito ? this.request.esito.tipoEsito.descrizione : null],
      dataProvvedimento: [this.request.esito ? this.request.esito.dataDeposito : null],
      tipoSchedaEsecuzione: [this.request.tipoSchedaEsecuzione ? this.request.tipoSchedaEsecuzione : null, Validators.required],
      sommaQuantificata: [this.request.sommaQuantificata],
      sommaNonQuantificata: [this.request.sommaNonQuantificata],
      adempimenti: [this.request.adempimenti],
      pagamentoSorteQuantificatoRuoloPaga: [this.request.pagamentoSorteQuantificatoRuoloPaga],
      pagamentoSorteQuantificatoBsf: [this.request.pagamentoSorteQuantificatoBsf],
      pagamentoSorteNonQuantificatoRuoloPaga: [this.request.pagamentoSorteNonQuantificatoRuoloPaga],
      pagamentoSorteNonQuantificatoBsf: [this.request.pagamentoSorteNonQuantificatoBsf],
      //tipoSomma: [this.request.tipoSomma, Validators.required],
      //importo: [this.request.importo],
      //modalitaErogazione: [this.request.modalitaErogazione],
      corrispondente: [this.request.corrispondente],
      note: [this.request.note]
    });
    // if(request.esito && this.edit){
    //   this.getContropartiBySocietaEsito(request.esito.societa.id);
    // }
   // this.onChangeTipoSomma(this.request.tipoSomma);
  }

  resetForm(){
    this.createForm(this.originalRequest);
  }

  getClassificazioniEsito():Classificazione[]{
    let classificazioniOptions:Classificazione[]=[];
    if(this.request.esito) {
      this.request.esito.dettagliEsito.forEach(dettaglio=>{
          if(!classificazioniOptions.find(el=>el.id===dettaglio.classificazione.id)) classificazioniOptions.push(dettaglio.classificazione);
      })
    }
    return classificazioniOptions;
  }

  getContropartiEsito():Controparte[]{
    let controparteOptions:Controparte[]=[];
    if(this.request.esito){
      this.request.esito.dettagliEsito.forEach(dettaglio=>{
          if(!controparteOptions.find(el=>el.id===dettaglio.controparte.id)) controparteOptions.push(dettaglio.controparte);
      })
    }
    return controparteOptions;
  }

  populateSelect(){
    if (this.tipoProvvedimentoOptions.length === 0) {
      this.helpers.getTipiEsiti().subscribe(response => this.tipoProvvedimentoOptions = response);
    }
    if(this.tipoSommaOptions.length===0){
      this.helpers.getTipiSommaDaCorrispondere().subscribe(response=> this.tipoSommaOptions=response);
    }
    if(this.modalitaErogazioneOptions.length===0){
      this.helpers.getModalitaErogazione().subscribe(response=>this.modalitaErogazioneOptions=response);
    }
    if(this.tipoEsecuzioneOptions.length===0){
      this.helpers.getTipiSchedaEsecuzione().subscribe(response=>this.tipoEsecuzioneOptions=response);
    }
  }

  manageModal(sezione: SezioneSchedeEsecuzione) {
      this.createForm();
      closeModal('modalmodaggiungischedaesecuzione');
      this.onReturn.emit(sezione);
  }

  initViewToggle() {
      this.visibleToggleAssocia = false;
      this.visibleToggleForm = true;
   if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  // onChangeTipoSomma(event){
  //   this.request.tipoSomma=event;
  //   if(this.request.tipoSomma && this.request.tipoSomma.descrizione=='QUANTIFICABILE'){
  //     this.disableSomma=false;
  //     this.schedaEsecuzioneForm.get('importo').setValidators([Validators.required]);
  //     this.schedaEsecuzioneForm.updateValueAndValidity();
  //   }
  //   else{
  //     this.disableSomma=true;
  //     this.request.importo=null;
  //     this.schedaEsecuzioneForm.get('importo').clearValidators();
  //     this.schedaEsecuzioneForm.updateValueAndValidity();
  //   }
  // }

  readSezioneEsiti(idSezioneEsiti: string) {
    if (idSezioneEsiti) {
      this.operationService.readSezione(this.urlSezioneEsiti, idSezioneEsiti)
        .subscribe(response =>
          this.readSezioneEsitiResponse((<SezioneEsitiResponse>response).sezione));
    }
  }

  readSezioneEsitiResponse(sezioneLegali: SezioneEsitiFull) {
    this.esitiAll = sezioneLegali.esiti;
  }

  // salvaFlag(){
  //   this.flagQuantificata=this.request.flagQuantificata;
  //   this.flagNonQuantificata=this.request.flagNonQuantificata;
  //   delete this.request.flagQuantificata;
  //   delete this.request.flagNonQuantificata;
  // }

  // inserisciFlag(schede: SchedaEsecuzione[]){
  //   for(let i=0;i<schede.length;i++){
  //     if(schede[i].esito.id===this.request.esito.id){
  //       schede[i].flagQuantificata=this.flagQuantificata;
  //       schede[i].flagNonQuantificata=this.flagNonQuantificata;
  //     }
  //   }
  // }

  associaEsito(esito: Esito) {
    this.getEsito(esito);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.populateSelect();
  }

  getEsito(obj: Esito) {
      this.request.esito = this.esitiAll.filter(el => { return el.id === obj.id; })[0];
      this.originalRequest.esito = this.esitiAll.filter(el => { return el.id === obj.id; })[0];
      //if(obj.societa) this.getContropartiBySocietaEsito(obj.societa.id);
  }

  // getContropartiBySocietaEsito(idSocieta){
  //    this.operationService.getContropartiBySocieta(idSocieta, this.idFascicolo).subscribe(res=>{
  //      this.request.controparti=res;
  //      this.originalRequest.controparti=res;
  //    });
  // }

  fixFlags(){
    if(!this.request.sommaQuantificata) this.request.sommaQuantificata = false;
    if(!this.request.sommaNonQuantificata) this.request.sommaNonQuantificata = false;
  }

  update() {
    this.fixFlags();
    if (this.edit) {
      this.operationService.updateSchedaEsecuzione(this.request, this.pathSchedeEsecuzioneUrl, this.idSezione, this.fascicolo.id).subscribe(
        response => {
          // this.inserisciFlag(response.sezione.schede);
          this.onReturn.emit(<SezioneSchedeEsecuzione> response.sezione);
          this.modalNotifyService.customMessage("L'operazione è andata a buon fine.");
          closeModal('modalmodaggiungischedaesecuzione');
        });
    } else {
      this.operationService.addSchedaEsecuzione(this.request, this.pathSchedeEsecuzioneUrl, this.idSezione, this.fascicolo.id).subscribe(
        response => {
          // this.inserisciFlag(response.sezione.schede);
          this.onReturn.emit(<SezioneSchedeEsecuzione> response.sezione);
          this.modalNotifyService.customMessage("L'operazione è andata a buon fine.");
          closeModal('modalmodaggiungischedaesecuzione');
        });
    }
  }
}
